import { useState, useEffect } from "react";
import { useGetAllStudentsQuery } from "src/services/StudentServices";

const useStudents = () => {
  const [students, setStudents] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllStudentsQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setStudents(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { students, isDataLoading };
};

export default useStudents;
